// @ts-nocheck
/* eslint-disable */
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SUREnet crm-public API
 * OpenAPI spec version: 1
 */

export type CrmRelationsRelatieContext =
  (typeof CrmRelationsRelatieContext)[keyof typeof CrmRelationsRelatieContext];

export const CrmRelationsRelatieContext = {
  Offerte: 'Offerte',
  Aanvraag: 'Aanvraag',
  Algemeen: 'Algemeen',
  VoorlopigeDekking: 'VoorlopigeDekking',
} as const;
